/* tslint:disable:variable-name */
import { User, UserUtilites } from '../../../index';
import { CaseHistoryRecordUserSnapshot } from './caseHistoryRecordUserSnapshot';

export class CaseHistoryRecord {
  action: string;
  caseHistoryRecordId: number;
  caseHistoryRecordUserSnapshot: CaseHistoryRecordUserSnapshot;
  created: number;
  details: string;
  user: User;

  private _createdDateTime: any;
  private _performedByUser: string;

  constructor(caseHistoryRecord: CaseHistoryRecord) {
    this.action = caseHistoryRecord.action;
    this.caseHistoryRecordId = caseHistoryRecord.caseHistoryRecordId;
    this.caseHistoryRecordUserSnapshot = caseHistoryRecord.caseHistoryRecordUserSnapshot;
    this.created = caseHistoryRecord.created;
    this.details = caseHistoryRecord.details;
    this.user = new User(caseHistoryRecord.user);
  }

  set createdDateTime(value) {
    this._createdDateTime = value;
  }
  get createdDateTime() {
    return new Date(this.created).toLocaleString('en-US', {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'UTC'});
  }
  set performedByUser(value) {
    this._performedByUser = value;
  }
  get performedByUser() {
    return UserUtilites.getUserFirstNameSpaceLastName(this.user)
  }


}
